<template>
    <div>
        <van-nav-bar
            title="预约详情"
            left-text="返回"
            left-arrow
            @click-left="clickback"
        />
        <van-cell-group>
            <van-cell title="店铺：" :value="data.shop_name" size="large" />
            <van-cell title="预约日期：" :value="data.time" size="large"/>
            <van-cell title="项目名称：" :value="data.project_name" size="large" />
            <van-cell title="车辆：" :value="data.code_no+data.carcategory_name" size="large"/>
            <van-cell title="状态：" :value="data.status" size="large" />
            <van-cell title="备注信息：" :value="data.rem" size="large"/>
        </van-cell-group>
        <div style="margin: 10px;">
            <van-button v-if="data.state==0" round block type="info" native-type="submit" @click="update()">
            取消预约
            </van-button>
        </div>
    </div>
</template>

<script>
import { NavBar, Button, Cell, CellGroup, Toast } from 'vant';
import { BookingApi } from '@/api/vip'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Button.name]: Button,
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
        [Toast.name]: Toast
    },
    data() {
        return {
            id: this.$route.params.id,
            data: {
                shop_name:'',
                project_name:'',
                start_time:'',
                end_time:'',
                time:'',
                code_no:'',
                carcategory_name:'',
                status:'',
                state: 0,
                rem:''
            },
            from:{}
        }
    },
    mounted(){
        this.getBookingDetail()
    },
    methods: {
        getBookingDetail(){
            var that = this
            that.axios.get(BookingApi+that.id+'/').then((ret) => {
                that.data.shop_name = ret.shop_name
                that.data.project_name = ret.project_name
                that.data.start_time = ret.start_time
                that.data.end_time = ret.end_time
                that.data.time = this.$moment(that.data.start_time).format('YYYY-MM-DD') + ' ' + this.$moment(that.data.start_time).format('HH:mm') + '-' + this.$moment(that.data.end_time).format('HH:mm')
                that.data.code_no = ret.code_no?ret.code_no:''
                that.data.carcategory_name = ret.car_detail?ret.car_detail.carcategory_name:''
                that.data.status = ret.status
                that.data.state = ret.state
                that.data.rem = ret.rem
                that.from = ret
            })
        },
        update(){
            var that = this
            that.from.state = 2
            that.axios.put(BookingApi + that.from.id + '/', that.from).then((ret) => {
                console.log(ret)
                Toast('取消完成')
                that.clickback()
            }).catch((ex) => {
                console.log(ex)
            })
        },
        clickback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(`/nt/user/booking`)
            }
        }
    }
}
</script>

<style lang="less" scoped>
</style>